<template>
  <v-row>
    <v-col>
      <v-row>
        <v-col class="py-0">
          <v-container fluid pt-0>
            <v-row justify="end" align="center">
              <div>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn class="mr-3" v-on="on" icon @click="onReloadList">
                      <v-icon dark>mdi-refresh</v-icon>
                    </v-btn>
                  </template>
                  <span>Refresh List</span>
                </v-tooltip>
              </div>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" fab dark color="primary" @click="onAddLog">
                    <v-icon dark>mdi-plus</v-icon>
                  </v-btn>
                </template>
                <span>Create New Log Entry</span>
              </v-tooltip>
            </v-row>
          </v-container>
        </v-col>
      </v-row>
      <v-data-table
        :items="formattedItems"
        :headers="headers"
        show-group-by
        class="log-table"
      >
        <template v-slot:item.eventDate="{ item }">{{
          item.eventDate | formatDate
        }}</template>
        <template v-slot:item.message="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on">
                {{ item.message }}
              </span>
            </template>
            <span>{{ item.message }}</span>
          </v-tooltip>
        </template>
      </v-data-table>
      <code v-if="debug">
        {{ value }}
      </code>
      <add-log-dialog
        :show="showAddLog"
        @close="showAddLog = false"
        @create="onCreateLog"
      ></add-log-dialog>
    </v-col>
  </v-row>
</template>

<script>
import gql from "graphql-tag";
import AddLogDialog from "./ItineraryDetailsAddLogDialog";

const CREATE_LOG = gql`
  mutation createItiLog($input: ItineraryLogInput!) {
    createItineraryLog(input: $input) {
      id
      message
      messageType
      userName
      eventDate
      eventTime
      marker
    }
  }
`;
export default {
  name: "itinerary-details-logs",

  props: {
    value: {
      type: Array,
      default: () => [],
    },
    itinerary: {
      type: Object,
      default: () => null,
    },
  },

  components: {
    AddLogDialog,
  },

  data() {
    return {
      debug: false,
      items: [...this.value],
      headers: [
        { text: "Date", value: "eventDate" },
        { text: "Time", value: "eventTime" },
        { text: "User", value: "userName" },
        { text: "Message Type", value: "messageType" },
        { text: "Message", value: "message" },
      ],
      showAddLog: false,
    };
  },

  computed: {
    formattedItems() {
      return this.items.map((item) => {
        return {
          ...item,
          message: this.formatMessage(item.message),
        };
      });
    },
  },

  methods: {
    onReloadList() {
      this.$emit("reload");
    },
    formatMessage(message) {
      return message.replace(/\d+(\.\d)/, (match) =>
        Number(match).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      );
    },
    onAddLog() {
      this.showAddLog = true;
    },
    onCreateLog(payload) {
      if (this.itinerary) {
        const input = { ...payload, itineraryId: this.itinerary.id };
        this.$apollo
          .mutate({
            mutation: CREATE_LOG,
            variables: { input },
          })
          .then((res) => {
            this.$store.dispatch("showAppSnackbar", {
              msg: "Log Entry Added.",
              color: "success",
            });
            this.showAddLog = false;
            this.items.unshift({ ...res.data.createItineraryLog });
          })
          .catch((err) => {
            this.$store.dispatch("showAppSnackbar", {
              msg: err,
              color: "warning",
            });
          });
      }
    },
  },

  watch: {
    value(newVal) {
      this.items = [...newVal];
    },
  },
};
</script>

<style scoped>
.v-data-table td {
  max-width: 0;
  /* overflow: hidden; */
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/gt/itineraries/ItineraryDetailsLogs.vue